<script lang="ts">
  import { createDialog, melt } from "@melt-ui/svelte";

  import { scalefade } from "$lib/ui/transitions/scalefade";

  export let src: string;
  export let alt: string | undefined = undefined;

  const {
    elements: { overlay, content, close, portalled },
    states: { open: fullscreen },
  } = createDialog();
</script>

<!-- svelte-ignore a11y-no-noninteractive-element-interactions -->
<img
  {src}
  {alt}
  class="my-6 mx-auto"
  on:click={() => fullscreen.set(true)}
  on:keypress={() => {}}
/>

{#if $fullscreen}
  <div
    class="fixed z-40 inset-0 flex flex-col justify-center items-center bg-ground/50"
    use:melt={$portalled}
  >
    <div use:melt={$overlay} class="absolute inset-0 bg-ground/50 -z-10"></div>
    <!-- The image is the content, but clicking on the image also closes the dialog. -->
    <img
      {src}
      {alt}
      class="max-h-screen cursor-zoom-out bg-ground"
      use:melt={$content}
      use:melt={$close}
      transition:scalefade
    />
  </div>
{/if}
